import { createActions } from 'redux-actions';

export const { getUserLocationFail, setUserLocation } = createActions({
    'getUserLocationFail': (err) => err,
    'setUserLocation':     (city, country, ip) => ({ city, country, ip }),
}, { prefix: 'GEO_IP' });
